import { render, staticRenderFns } from "./sortingAddEdit.vue?vue&type=template&id=422c6dd5&scoped=true&"
import script from "./sortingAddEdit.vue?vue&type=script&lang=js&"
export * from "./sortingAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./sortingAddEdit.vue?vue&type=style&index=0&id=422c6dd5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c6dd5",
  null
  
)

export default component.exports